import React from "react";
import AudioLevelIndicator from "../../AudioLevelIndicator/AudioLevelIndicator";
import { LocalAudioTrack } from "twilio-video";
import { FormControl, MenuItem, Typography, Select, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SELECTED_AUDIO_INPUT_KEY } from "../../../../constants";
import useDevices from "../../../../hooks/useDevices/useDevices";
import useMediaStreamTrack from "../../../../hooks/useMediaStreamTrack/useMediaStreamTrack";
import useVideoContext from "../../../../hooks/useVideoContext/useVideoContext";
import { typography } from "../../../../utils/typography";
import { semanticColors } from "../../../../utils/colors";

export default function AudioInputList() {
  const { t } = useTranslation();
  const { audioInputDevices } = useDevices();
  const { localTracks } = useVideoContext();

  const localAudioTrack = localTracks.find(
    track => track.kind === "audio"
  ) as LocalAudioTrack;
  const srcMediaStreamTrack = localAudioTrack?.noiseCancellation?.sourceTrack;
  const mediaStreamTrack = useMediaStreamTrack(localAudioTrack);
  const localAudioInputDeviceId =
    srcMediaStreamTrack?.getSettings().deviceId ||
    mediaStreamTrack?.getSettings().deviceId;

  function replaceTrack(newDeviceId: string) {
    window.localStorage.setItem(SELECTED_AUDIO_INPUT_KEY, newDeviceId);
    localAudioTrack?.restart({ deviceId: { exact: newDeviceId } });
  }

  return (
    <div>
      <Typography
        sx={{
          ...typography.body.m,
          color: semanticColors.text.secondary,
          mb: "0.5em"
        }}
      >
        {t("settings.audioInput")}
      </Typography>
      <Grid container alignItems="center" justifyContent="space-between">
        <div className="inputSelect">
          {audioInputDevices.length > 1 ? (
            <FormControl fullWidth>
              <Select
                onChange={e => replaceTrack(e.target.value as string)}
                value={localAudioInputDeviceId || ""}
                variant="outlined"
              >
                {audioInputDevices.map(device => (
                  <MenuItem value={device.deviceId} key={device.deviceId}>
                    {device.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          ) : (
            <Typography
              sx={{ ...typography.body.l, color: semanticColors.text.primary }}
            >
              {localAudioTrack?.mediaStreamTrack.label ||
                t("settings.noLocalAudio")}
            </Typography>
          )}
        </div>
        <AudioLevelIndicator audioTrack={localAudioTrack} color="black" />
      </Grid>
    </div>
  );
}
